'use client';

import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { useMedia } from 'react-use';

import { SocialShareBlock } from '@/components/SocialShareBlock/SocialShareBlock';

import styles from './StickyShare.module.scss';

const Sticky = dynamic(() => import('react-stickynode'), { ssr: false });

interface Props {
    className?: string;
    marginTop?: number;
    iconClassName?: string;
    stickyFor?: number;
    title?: string;
    text?: string;
    boundaryNode: string;
}

export function StickyShare({
    className,
    iconClassName,
    marginTop,
    stickyFor,
    title,
    text,
    boundaryNode,
}: Props) {
    const isDesktop = useMedia(`(min-width: ${stickyFor}px)`, false);

    return (
        <div className={classNames(className, styles.stickyShare)}>
            <Sticky
                enabled={isDesktop}
                top={marginTop}
                bottomBoundary={`.${boundaryNode}`}
                className={styles.content}
            >
                <SocialShareBlock
                    text={text}
                    title={title}
                    iconClassName={classNames(iconClassName, styles.icon)}
                />
            </Sticky>
        </div>
    );
}
